import { render, staticRenderFns } from "./StudProgram.vue?vue&type=template&id=dee1ea0a&scoped=true&"
import script from "./StudProgram.vue?vue&type=script&lang=js&"
export * from "./StudProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee1ea0a",
  null
  
)

export default component.exports